import { useSnapshot } from "valtio";
import { state } from "../store";
import "./HullColorsPanel.css";

export default function HullColorsPanel() {
  const snap = useSnapshot(state);

  const isOpen = snap.openedPanel === "hull-colors";

  const handleClose = () => {
    state.openedPanel = null;
  };

  // Define hull-specific color presets
  const hullColors = [
    {
      name: "Pearl White",
      color: "#e1e7ed",
    },
    {
      name: "Light Blue",
      color: "#b9d2fc",
    },
    {
      name: "Sky Blue",
      color: "#e3edfd",
    },

    {
      name: "Ocean Blue",
      color: "#454a4d",
    },
    {
      name: "Deep Navy",
      color: "#404c7e",
    },
    {
      name: "Sea Green",
      color: "#0d7c9f",
    },
    {
      name: "Forest Green",
      color: "#2c889e",
    },
    {
      name: "Midnight Black",
      color: "#1f2937",
    },
    {
      name: "Coral Pink",
      color: "#2c9e83",
    },
    {
      name: "Royal Purple",
      color: "#802305",
    },
  ];

  const applyHullColor = (colorPreset) => {
    // Store hull-specific color for bottom_hull_white material ONLY
    state.hullColor = colorPreset.color;

    // Do NOT update waterColor - keep hull and seats colors independent
    // Do NOT close panel automatically - let user close manually
  };

  // Helper function to adjust brightness of a color
  const adjustBrightness = (hex, percent) => {
    const num = parseInt(hex.replace("#", ""), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) + amt;
    const G = ((num >> 8) & 0x00ff) + amt;
    const B = (num & 0x0000ff) + amt;
    return "#" + (0x1000000 + (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 + (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 + (B < 255 ? (B < 1 ? 0 : B) : 255)).toString(16).slice(1);
  };

  // Helper function to convert hex to HSL
  const hexToHsl = (hex) => {
    const r = parseInt(hex.slice(1, 3), 16) / 255;
    const g = parseInt(hex.slice(3, 5), 16) / 255;
    const b = parseInt(hex.slice(5, 7), 16) / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h,
      s,
      l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    return {
      h: Math.round(h * 360),
      s: Math.round(s * 100),
      l: Math.round(l * 100),
    };
  };

  return (
    <>
      {isOpen && (
        <>
          <h2 className="panel-title">HULL COLORS</h2>
          <div className="hull-colors-wrapper">
            <div className="hull-colors-panel">
              <div className="hull-colors-grid">
                {hullColors.map((colorPreset, index) => (
                  <div key={index} className="hull-color-item" onClick={() => applyHullColor(colorPreset)}>
                    <div
                      className="hull-color-swatch"
                      style={{
                        "--color": colorPreset.color,
                        "--color-light": adjustBrightness(colorPreset.color, 30),
                      }}
                    ></div>
                  </div>
                ))}
              </div>
              <button className="close-button-hull-colors" onClick={handleClose}>
                <svg viewBox="0 0 24 24">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
